module.exports = __webpack_public_path__ + "img/event.5b325f53.jpeg";